import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgTranexamicAcidGlyphSecondary from './svgs/TranexamicAcidGlyphSecondary.js';
import SvgTranexamicAcidGlyph from './svgs/TranexamicAcidGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var tranexamicAcidGlyph = (props => useIcon(SvgTranexamicAcidGlyph, SvgTranexamicAcidGlyphSecondary, props));

export { tranexamicAcidGlyph as default };
